import axios from 'axios';
import { API_ENDPOINT_URL, SIGN_IN_API_ENDPOINT } from "../constants/default";

// Basic Authentication for accessing Shutterstock API
// const basicAuth = () => 'Basic '.concat(window.btoa(`${SHUTTER_CLIENT_ID}:${SHUTTER_CLIENT_SECRET}`));
// const authParameters = {
//   headers: {
//     Authorization: basicAuth()
//   }
// };

/**
* Description [Access Shutterstock search endpoint for short videos]
* @params { String } searchQuery
* @return { Array }
*/

export const signUpRequest = (payload) => {
    return axios.post(`${API_ENDPOINT_URL}/auth/signup`, {
        email: payload.email,
        password: payload.password_2,
        first_name: payload.first_name,
        last_name: payload.last_name
    }).then((res) => {
        if (res.data.user) {
            setAccessToken(res.data.access_token);
            setUserID(res.data.user.id);
            setUser(res.data.user);
            return { success: true };
        } else {
            return { success: false, reason: res.message };
        }
    }).catch((err) => {
        return { success: false, reason: err.response.data.message };
    })
};


// get packages
export const fetchPackagesRequest = (payload) => {
  return axios.get(`${API_ENDPOINT_URL}/channels/packages/?channel_ids=${payload.channel_ids}`, {
    // Include additional body items if needed
  }).then((res) => {
      return { success: true, data: res.data };
  }).catch((err) => {
      return { success: false, reason: err.response.data.message };
  })
};


function setAccessToken(token) {
    localStorage.setItem('access_token', token);
}

function getAccessToken() {
    return localStorage.getItem('access_token');
}

function setUserID(id) {
    localStorage.setItem('user_id', id);
}

function setUser(user) {
    localStorage.setItem('user', JSON.stringify(user));
}

export const getUserID = () => {
    if (!localStorage.getItem('user_id')) {
        return false
    }
    return localStorage.getItem('user_id')
}

export const getUser = () => {
    if (!localStorage.getItem('user')) {
        return false;
    }
    return JSON.parse(localStorage.getItem('user'));
}

export const logOut = () => {
    localStorage.setItem('access_token', null);
    localStorage.setItem('user_id', null);
    localStorage.setItem('user', null);
}

// function getUserID() {
//   return localStorage.getItem('user_id');
// }



// WEBPACK FOOTER //
// ./src/api/Api.js